import React from 'react';
import { Link } from 'react-router-dom';

import Pagination from '../common/Pagination';
import SectionHeader from '../common/SectionHeader';
import ClientService from '../../services/ClientService';
import ClientFilter from './ClientFilter';
import ClientsTable from './ClientsTable';

const pageLimit = 10;
const pageRange = 5;

class ClientList extends React.Component {
  constructor(props) {
    super(props);

    this.onSearch = this.onSearch.bind(this);
    this.onClear = this.onClear.bind(this);
    this.onPageIndexChanged = this.onPageIndexChanged.bind(this);

    this.state = {
      filter: {},
      currentPage: 1,
      totalCount: 0,
      clients: []
    };
  }

  loadData() {

    const reqParams = {
      ...this.state.filter,
      page: { number: this.state.currentPage, size: pageLimit }
    }

    ClientService
      .get(reqParams)
      .then(result => {
        this.setState({
          clients: result.items,
          totalCount: result.totalCount
        });
      });
  }

  componentDidMount() {
    this.loadData();
  }

  onSearch(criteria) {
    this.setState({ filter: criteria, currentPage: 1 }, this.loadData);
  }

  onClear() {
    this.setState({ filter: {}, currentPage: 1 }, this.loadData);
  }

  onPageIndexChanged(page) {
    if (this.state.currentPage !== page) {
      this.setState({ currentPage: page }, this.loadData);
    }
  }

  render() {
    return (
      <React.Fragment>
        <SectionHeader title="Requirements">
          <Link to="/requirements/create" className="create-new" title="Create New" data-icon="&#xe91c;">Create New</Link>
        </SectionHeader>
        <ClientFilter
          onSearch={this.onSearch}
          onClear={this.onClear} />
        <ClientsTable
          clients={this.state.clients} />
        <Pagination
          currentPage={this.state.currentPage}
          pageSize={pageLimit}
          totalCount={this.state.totalCount}
          visibleRange={pageRange}
          onPageChanged={this.onPageIndexChanged}
        />
      </React.Fragment>
    );
  }
}

export default ClientList;



// WEBPACK FOOTER //
// ./src/components/clients/ClientList.js